<app-auth-pages>
    <ng-container *transloco="let t;">

        <h2 class="card-title form-title-text mb-1 text-black">{{ t('register header (register page) - Create an
            account') }}
        </h2>
        <app-social-logins-links></app-social-logins-links>
        <div class="divider my-2">
            <div class="divider-text">{{t('Or text (general) - or')}}</div>
        </div>
        <form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="register-email" class="form-label ">{{t('Email (general) - Email')}}</label>
                <input type="text" formControlName="email" class="form-control placeholder-text"
                    placeholder="name@company.com" aria-describedby="register-email" tabindex="1" autofocus
                    [ngClass]="{ 'is-invalid': submitted && form.email.errors }" />
                <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                    <div *ngIf="form.email.errors.required">
                        {{ t('Field required (form validation) - Field name is required', {
                        fieldName: t('Email (general) - Email')
                        }) }}
                    </div>
                    <div *ngIf="form.email.errors.email">{{ t('Email must be a valid email address (general) - Email
                        must be a valid email address') }}</div>
                </div>
            </div>
            <div class="row custom-row">
                <div class="col-6 custom-column">
                    <div class="form-group">
                        <label for="register-firstname" class="form-label">{{ t('First name (general) - First
                            name')
                            }}</label>
                        <input id="register-firstname" type="text" formControlName="firstName"
                            class="form-control placeholder-text" placeholder="John"
                            aria-describedby="register-firstname" tabindex="2"
                            [ngClass]="{ 'is-invalid': submitted && form.firstName.errors }" />
                        <div *ngIf="submitted && form.firstName.errors" class="invalid-feedback">
                            <div *ngIf="form.firstName.errors.required">{{ t('Field required (form validation) - Field name is required', {
                                fieldName: t('First name (general) - First name')}) }}</div>
                        </div>
                    </div>
                </div>
                <div class="col-6 custom-column">
                    <div class="form-group">
                        <label for="register-lastname" class="form-label">{{ t('Last name (general) - Last
                            name')
                            }}</label>
                        <input id="register-lastname" type="text" formControlName="lastName"
                            class="form-control placeholder-text" placeholder="Doe" aria-describedby="register-lastname"
                            tabindex="3" [ngClass]="{ 'is-invalid': submitted && form.lastName.errors }" />
                        <div *ngIf="submitted && form.lastName.errors" class="invalid-feedback">
                            <div *ngIf="form.lastName.errors.required">{{ t('Field required (form validation) - Field name is required', {
                                fieldName: t('Last name (general) - Last name')}) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="register-password" class="form-label">{{ t('Password - label (general) - Password')
                    }}</label>

                <div class="input-group input-group-merge form-password-toggle">
                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
                        class="form-control form-control-merge placeholder-text" placeholder="············"
                        aria-describedby="register-password" tabindex="4"
                        [ngClass]="{ 'is-invalid error': submitted && form.password.errors }" />
                    <div class="input-group-append">
                        <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }" (click)="togglePasswordTextType()"></i></span>
                    </div>
                </div>
                <div *ngIf="submitted && form.password.errors" class="invalid-feedback"
                    [ngClass]="{ 'd-block': submitted && form.password.errors }">
                    <div *ngIf="form.password.errors.required">{{ t('Field required (form validation) - Field name is required', {
                        fieldName: t('Password - label (general) - Password')
                        }) }}</div>
                    <div *ngIf="form.password.errors.pattern">{{
                        t('New Password field validation message (Change password - section) - New Password must contain more than 8 characters 1 numeric 1 upper case letter and 1 special character')
                        }}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" formControlName="terms"
                        id="register-privacy-policy" tabindex="5" />
                    <label class="custom-control-label checkbox-text" for="register-privacy-policy">
                        {{ t('Agreement statement part 1 (Register page) - I agree ') }} <a
                            href="javascript:void(0);">{{t('Agreement statement part 2 (Register page) - privacy policy
                            and terms')}}</a>
                    </label>
                    <div *ngIf="submitted && form.terms.errors" class="invalid-feedback"
                        [ngClass]="{ 'd-block': submitted && form.terms.errors }">
                        <div *ngIf="form.terms.errors.pattern">{{t('Agreement statement validation text (Register page)
                            - You must agree with terms')}}</div>
                    </div>
                </div>
            </div>
            <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="6" rippleEffect>
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> {{ t('Sign up button text
                (Register page) - Sign up') }}
            </button>
        </form>
        <p class="text-center mt-2 desktop-only text-muted">
            <span>{{ t('Already have an account question (Register page) - Already have an account') }}?</span><a
                routerLink="/login"><span>&nbsp;{{ t('Sign in instead text (Authorization pages) - Sign in instead')
                    }}</span></a>
        </p>

        <p class="text-center mt-2 desktop-only text-muted">
            <span>{{ t('Still on old platform text (Login page) - Not updated to the new platform yet?') }}</span><a
                href="https://esign.simplesign.io/login"><span>&nbsp;{{ t('Old version login text (Login page) - Switch
                    back to the old version here.') }}</span></a>
        </p>
    </ng-container>
</app-auth-pages>